import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AccessTypeT, ScopeT } from 'business/definitions';
import PermissionEditor from '../PermissionEditor/PermissionEditor';
import { useUserCreationFormContext } from '../../../../CreateUserContext/CreateUserFormContext';
import {
    getBudgetWriteBlocks,
    getWriteScopeAccessTypeButton,
} from '../../helpers/scopes';
import ScopeBlocksEditor from './ScopeBlocksEditor';
import { useGetAccessTypeUpdaterWriteScope } from '../../hooks/accessType';
import {
    useGetWriteScopeBlockValueRemover,
    useGetWriteScopeBlockValuesUpdater,
} from '../../hooks/blockValues';

const WriteScopeEditor = ({ scope }: { scope: ScopeT }) => {
    const { t } = useTranslation();

    const { writeScopes: userWriteScopes } = useUserCreationFormContext();

    const [accessType, setAccessType] = useState<AccessTypeT>('no_access');

    useEffect(() => {
        const currentUserScope = userWriteScopes.find(
            (userWriteScope) => userWriteScope.name === scope.name,
        );
        setAccessType(
            currentUserScope ? currentUserScope.accessType : 'no_access',
        );
    }, [scope.name]);

    const updateAccessType = useGetAccessTypeUpdaterWriteScope(scope);
    const onUpdateBlockValues = useGetWriteScopeBlockValuesUpdater(scope);
    const onRemoveBlockValue = useGetWriteScopeBlockValueRemover(scope);
    const blocks = getBudgetWriteBlocks(scope);

    return (
        <>
            <PermissionEditor
                title={t(
                    'adminSpace.createUser.modalStepper.writeScopesSection.title',
                )}
                accessType={accessType}
                accessTypeButtons={getWriteScopeAccessTypeButton(scope)}
                updateAccessType={(newAccessType) => {
                    updateAccessType(newAccessType);
                    setAccessType(newAccessType);
                }}
            >
                <ScopeBlocksEditor
                    scope={scope}
                    userScopes={userWriteScopes}
                    title={t(
                        'adminSpace.createUser.modalStepper.writeScopesSection.subtitle',
                    )}
                    blocks={blocks}
                    onUpdateBlockValues={onUpdateBlockValues}
                    onRemoveBlockValue={onRemoveBlockValue}
                />
            </PermissionEditor>
        </>
    );
};

export default WriteScopeEditor;
